import React, { useState, useEffect, useContext } from "react";
import { ref, onValue } from "firebase/database"; // Removed 'update', 'remove', 'push', 'set'
import { database } from "./firebaseConfig";
import { UserContext } from "./UserContext";
import { Search } from "lucide-react";

// Import UI components
import { ScrollArea } from "./components/ui/scroll-area";
import { Input } from "./components/ui/input";
import Header from "./components/header";
import Loader from "./components/loader";
import PublicListing from "./components/public-listing";

export default function Home() {
  const { currentUser } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [publicLists, setPublicLists] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    setError(null);

    // Fetch lists
    const listsRef = ref(database, "lists");
    const unsubscribeLists = onValue(
      listsRef,
      (snapshot) => {
        const data = snapshot.val();
        setPublicLists(
          Object.entries(data || {}).filter(
            ([_, list]) => list && list.privacy === "public"
          )
        );
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching lists:", error);
        setError("Failed to load lists. Please try again later.");
        setIsLoading(false);
      }
    );

    return () => {
      unsubscribeLists();
    };
  }, [currentUser]);

  if (error) {
    return <p className="text-center text-gray-100 mt-8">Error: {error}</p>;
  }

  const filteredPublicLists = publicLists?.filter(([_, list]) =>
    list.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <Header />

      <main className="container mx-auto px-4 py-8">
        <div
          className="bg-gray-800 rounded-xl shadow-2xl overflow-hidden"
          style={{ height: "calc(100vh - 180px)" }}
        >
          <div className="p-6 h-full flex flex-col">
            <h2 className="text-2xl font-semibold mb-4 text-green-400 flex items-center">
              <Search className="mr-2" /> Discover Public Lists
            </h2>
            <div className="mb-4">
              <Input
                type="text"
                placeholder="Search public lists..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="bg-gray-700 text-gray-100 border-gray-600"
              />
            </div>
            {isLoading ? (
              <Loader />
            ) : (
              <ScrollArea className="flex-1">
                <ul className="space-y-4">
                  {filteredPublicLists?.map(([listId, list]) => (
                    <PublicListing key={listId} listId={listId} list={list} />
                  ))}
                </ul>
              </ScrollArea>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
